import { Form, TextArea } from '@mairistem/composants';
import { Panel, type PanelClass } from '@mairistem/finances-utils';
import React from 'react';

interface ResumeComponentProps {
	data: {
		resume?: string;
	};
	handlePin: () => void;
	onChange?: (updatedData: { [key: string]: any }) => void;
	panel: PanelClass;
}

const ResumeComponent = ({
	data,
	handlePin,
	onChange,
	panel,
}: ResumeComponentProps) => {
	const handleChange = (
		_e: React.ChangeEvent<HTMLTextAreaElement>,
		{ name, value }: { name: string; value: string },
	) => onChange?.({ [name]: value });

	return (
		<Panel panel={panel} onPin={handlePin}>
			<Form>
				<Form.Field
					key="resume"
					name="resume"
					value={data?.resume ?? ''}
					fluid
					// @ts-expect-error
					control={TextArea}
					onChange={handleChange}
					data-testid="resumeProjet"
					rows={4}
				/>
			</Form>
		</Panel>
	);
};

export default ResumeComponent;
